<template lang="pug">
  transition(name="fade")
    .popup
      .popup__content
        slot

</template>

<script>
export default {

  props:{

  },
  name: 'app-popup',
  components: {
    
  },
  data() {
    return {
      
    }
  },
  methods:{
    
  },
  computed:{
    
  }
}
</script>

<style lang="scss">
.fade-enter-active, .fade-leave-active {
    transition: opacity .3s
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0
  }
  .popup {
    position: absolute;
    top:0;
    bottom:0;
    left:0;
    right:0;
    width:100%;
    height:100%;
    background-color: rgba(#000, .6);
    z-index: 100;
    &__content {
      @include centered;
      max-width: 600px;
      width:100%;
    }
  }

</style>
